import { Campaign } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { SortDirection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/enums.pb';

const SORT_DIRECTION_KEY = 'bulk-messaging-direction';

/**
 * Retrieves the current campaign sort direction from session storage.
 *
 * @returns The stored sort direction, or DESCENDING as the default if no value is stored
 */
export const getCampaignsSort = () =>
  (sessionStorage.getItem(SORT_DIRECTION_KEY) as SortDirection) ?? SortDirection.DESCENDING;

/**
 * Persists the campaign sort direction to session storage.
 *
 * @param direction - The sort direction to store (ASCENDING or DESCENDING)
 */
export const setCampaignsSort = (direction: SortDirection) => sessionStorage.setItem(SORT_DIRECTION_KEY, direction);

/**
 * Sorts an array of campaigns by their startSendAt date according to the sort direction stored in session storage. Falsy campaigns are removed.
 *
 * @template T - Type that extends Campaign
 * @param campaigns - Array of campaigns to sort
 * @returns A new sorted array of campaigns, or an empty array if input is falsy
 */
export const sortCampaigns = <T extends Campaign>(campaigns: T[]): T[] =>
  campaigns?.filter(Boolean)?.sort((a, b) => {
    const sortDirection = getCampaignsSort();
    if (a.startSendAt === b.startSendAt) return 0;
    if (sortDirection === SortDirection.DESCENDING) return b.startSendAt?.localeCompare(a.startSendAt!) ?? 0;
    return a.startSendAt?.localeCompare(b.startSendAt!) ?? 0;
  }) ?? [];
